import React from 'react';

import { findObject } from './PathObjects';
import { getFieldLabel } from './PathObjectFields/index';

export const styles = {
  status: {
    color: '#adadad',
    fontSize: '0.8em',
    lineHeight: '1.5em',
  },
  hint: {
    margin: 0,
  },
  list: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    '& li': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
};

export const Status = ({ item, objects, intl }) => {
  const {
    metaData: { objectValue, fieldValues },
  } = item;

  if (!objectValue || !fieldValues) {
    return <React.Fragment />;
  }

  const objLabel = intl.formatMessage({
    id: 'journeyBuilder.decisionSplit_object',
  });

  const obj = findObject(objects, item);

  const arr = [
    {
      label: `${objLabel}`,
      value: `${obj.name}`,
    },
    ...(fieldValues &&
      Object.getOwnPropertyNames(fieldValues).map(x => {
        const field = obj.fields && obj.fields.find(item => item.code === x);
        return {
          label: field && field.name,
          value: `${getFieldLabel(obj.fields, x, fieldValues)}`,
        };
      })),
  ];

  return (
    <React.Fragment>
      {arr.filter(x => x.value).map(x => (
        <li key={`${x.label}`}>
          <strong>{`${x.label}: `}</strong>
          <span>{x.value}</span>
        </li>
      ))}
    </React.Fragment>
  );
};

Status.displayName = 'Status';

const PathStatusComponent = ({ classes, intl, hint, item, objects }) => (
  <div className={classes.status}>
    {hint && <p className={classes.hint}>{hint}</p>}
    {item && (
      <ul className={classes.list}>
        <Status item={item} objects={objects} intl={intl} />
      </ul>
    )}
  </div>
);

PathStatusComponent.displayName = 'PathStatusComponent';

export default PathStatusComponent;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathStatusComponent.js